var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import store from 'src/store';
import { CognitoAPI } from './cognitoApi';
import { addNotificationsData } from 'src/store/actions/notifications.actions';
var userData = {
    cognito: null,
    tubeId: null,
    orgId: null,
    originalOrgId: null,
};
// todo: find better way
var mainApi;
var mainApiUsers;
var mainApiCommand;
export var setOrginalOrgId = function (originalOrgId) {
    userData.originalOrgId = originalOrgId;
};
var fetchResponse = function (res) {
    var json = res.json();
    if (res.status >= 200 && res.status < 300) {
        return json;
    }
    else {
        if (res.status === 502 && res.type === 'cors') {
            throw 'no organization found';
        }
        return json.then(Promise.reject.bind(Promise));
    }
};
export function getOrganization(id, mainApiUrl, mainApiUrlCommand, mainApiUsersUrl, isAuthorizedPage) {
    mainApi = mainApiUrl;
    mainApiUsers = mainApiUsersUrl;
    mainApiCommand = mainApiUrlCommand;
    userData.orgId = id;
    return fetch(mainApi + "/organizations/" + id + (isAuthorizedPage ? "?fetchShareInfo=" + isAuthorizedPage : ''))
        .then(fetchResponse)
        .then(function (res) { return (Object.keys(res).length === 0 ? Promise.reject({ message: 'no organization found' }) : res); })
        .then(function (org) {
        localStorage.setItem('tubeId', org.tubeId);
        return org;
    });
}
export function getOrganizationDomainFromOrgId(orgId, mainApiUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var apiData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    mainApi = mainApiUrl;
                    return [4 /*yield*/, fetch(mainApi + "/getDomainFromOrganizationId" + ("?orgId=" + orgId)).then(fetchResponse)];
                case 1:
                    apiData = _a.sent();
                    return [2 /*return*/, (apiData === null || apiData === void 0 ? void 0 : apiData.domain) || orgId];
            }
        });
    });
}
export function getNotifications(params) {
    return __awaiter(this, void 0, void 0, function () {
        var lang, data, newNotifications, currentState, currentNotificationsIds_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    lang = localStorage.getItem('lang') || 'en-us';
                    return [4 /*yield*/, axios({
                            method: 'GET',
                            url: mainApi + "/notifications?lang=" + lang,
                            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
                        })];
                case 1:
                    data = _a.sent();
                    newNotifications = [];
                    if (params && params.isFirstFetch) {
                        //  Do nothing
                    }
                    else {
                        currentState = store.getState();
                        currentNotificationsIds_1 = currentState.notifications.data.map(function (item) { return item.id; });
                        newNotifications = data.data.data.filter(function (item) { return !currentNotificationsIds_1.includes(item.id); });
                    }
                    addNotificationsData(data.data)(store.dispatch);
                    return [2 /*return*/, newNotifications];
            }
        });
    });
}
export function getUserFromEmail(email) {
    return fetch(mainApi + "/userFromEmail?email=" + email + "&orgId=" + userData.originalOrgId).then(function (res) { return res.json(); });
}
export function getEmbedData(id, key) {
    return fetch(mainApi + "/getVideoEmbed?key=" + key + "&orgId=" + id).then(function (res) { return res.json(); });
}
export function getUserPermissions() {
    return axios({
        method: 'GET',
        url: mainApi + "/initData",
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
    }).then(function (res) { return res.data; });
}
export function getTube() {
    return axios({
        method: 'GET',
        url: mainApi + "/tube",
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
    }).then(function (res) { return res.data; });
}
export function getLanguageData(lang) {
    return axios({
        method: 'GET',
        url: lang ? mainApi + "/language?language=" + lang : mainApi + "/language",
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
    }).then(function (res) { return res.data; });
}
export var initializeCognito = function (org) {
    userData.cognito = new CognitoAPI({
        orgId: org.id,
        userPoolId: org.userPoolId,
        clientId: org.userPoolClientId,
    });
    return userData.cognito.sessionLogin(org.ssoUrl);
};
export function sessionLogin(ssoUrl) {
    return userData.cognito.sessionLogin(ssoUrl);
}
export function signIn(username, password) {
    return userData.cognito.signIn(username, password);
}
export function signUp(email, password, orgId) {
    return userData.cognito.signUp(email, password, orgId);
}
export function resendConfirmationCode(email) {
    return userData.cognito.resendConfirmationCode(email);
}
export function confirmRegistration(email, password, code) {
    return userData.cognito.confirmRegistration(email, password, code);
}
export function signOut() {
    return userData.cognito.signOut();
}
export function forgotPassword(email) {
    return userData.cognito.forgotPassword(email);
}
export function confirmPassword(email, password, code) {
    return userData.cognito.confirmPassword(email, password, code);
}
// todo: move from "orgApi"
export function uploadFile(params, cb) {
    if (cb === void 0) { cb = function (data) { }; }
    return axios({
        method: 'post',
        url: mainApiCommand + "/getS3UploadSignedUrl",
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        data: {
            fileExt: params.file.name.split('.').pop(),
        },
    })
        .then(function (res) { return res.data; })
        .then(function (data) {
        return axios({
            method: 'put',
            url: data.signedUrl,
            headers: {
                'content-type': params.file.type,
            },
            data: params.file,
            onUploadProgress: cb,
        }).then(function () { return ({
            id: params.id,
            fileName: data.fileName,
            s3Path: data.s3Path,
        }); });
    });
}
// todo: should be replaced with dropzone multiple files upload
export function uploadFiles(params, cb) {
    if (cb === void 0) { cb = function (data, id) { }; }
    return __awaiter(this, void 0, void 0, function () {
        var resObj, _loop_1, _i, params_1, item;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    resObj = {};
                    _loop_1 = function (item) {
                        var data;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    if (!item.file)
                                        return [2 /*return*/, "continue"];
                                    return [4 /*yield*/, axios({
                                            method: 'post',
                                            url: mainApiCommand + "/getS3UploadSignedUrl",
                                            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
                                            data: {
                                                fileExt: item.file.name.split('.').pop(),
                                            },
                                        })];
                                case 1:
                                    data = (_b.sent()).data;
                                    return [4 /*yield*/, axios({
                                            method: 'put',
                                            url: data.signedUrl,
                                            headers: {
                                                'content-type': item.file.type,
                                            },
                                            data: item.file,
                                            onUploadProgress: function (data) { return cb(data, item.id); },
                                        })];
                                case 2:
                                    _b.sent();
                                    resObj[item.id] = data.fileName || data.s3Path;
                                    return [2 /*return*/];
                            }
                        });
                    };
                    _i = 0, params_1 = params;
                    _a.label = 1;
                case 1:
                    if (!(_i < params_1.length)) return [3 /*break*/, 4];
                    item = params_1[_i];
                    return [5 /*yield**/, _loop_1(item)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, resObj];
            }
        });
    });
}
export function createUser(email) {
    return axios({
        method: 'POST',
        url: mainApiUsers + "/createUser",
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        data: { email: email },
    }).then(function (res) { return res.data; });
}
export function updateUserStatus(params) {
    return axios({
        method: 'POST',
        url: mainApiUsers + "/updateUserStatus",
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        data: __assign({}, params),
    }).then(function (res) { return res.data; });
}



//////////////////
// WEBPACK FOOTER
// ./src/auth/cognito/organizationApi.ts
// module id = 65
// module chunks = 81